// MUST be first: restores crypto.randomUUID, which the browser withholds outside a secure
// context (this portal is served over plain HTTP). See the file for the full explanation.
import './secureContextPolyfill';
import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
// MUST come after the line above: it overrides --bui-font-regular, and the later
// stylesheet wins at equal specificity. See brand.css.
import './brand.css';

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
